import React, { useEffect, useState } from "react";
import "./styles.scss";
import Icon from "./icon.svg";

const CheckBox = (props) => {
  "use strict";
  const [checkboxState, setCheckboxState] = useState(false);
  const handleOnChange = (e) => {
    checkboxState ? setCheckboxState(false) : setCheckboxState(true);
    props.onChange(e);
  };

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("formData"))) {
      const localDataObj = JSON.parse(localStorage.getItem("formData"));

      if (localDataObj.serviceList && localDataObj.serviceList.indexOf(props.value) !== -1) {
        setCheckboxState(true);
      }
      if (localDataObj.educationList && localDataObj.educationList.indexOf(props.value) !== -1) {
        setCheckboxState(true);
      }
      if (localDataObj.skillsList && localDataObj.skillsList.indexOf(props.value) !== -1) {
        setCheckboxState(true);
      }
    }
  }, []);

  return (
    <label className={"checkbox-widget"} data-checked={checkboxState} htmlFor={props.id}>
      <input
        type="checkbox"
        name={props.name}
        value={props.value}
        onChange={(e) => handleOnChange(e)}
        data-checked={checkboxState}
        id={props.id}
      />
      <img src={Icon} alt="" />
    </label>
  );
};

export default CheckBox;
